import { render, staticRenderFns } from "./TableViewerWidget.vue?vue&type=template&id=9bcc8b8c&scoped=true&"
import script from "./TableViewerWidget.vue?vue&type=script&lang=js&"
export * from "./TableViewerWidget.vue?vue&type=script&lang=js&"
import style0 from "./TableViewerWidget.vue?vue&type=style&index=0&id=9bcc8b8c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bcc8b8c",
  null
  
)

export default component.exports
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QPagination from 'quasar/src/components/pagination/QPagination.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QSeparator,QPagination});
